import axios from 'axios';
import Auth from '../utils/Auth';
import { apiUrl } from './AuthApi';

const client = axios.create({
  baseURL: apiUrl
});

client.interceptors.request.use(
  (config) => {
    const token = Auth.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      Auth.deauthenticateUser();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const sendAIMessage = async ({ message, context, conversationId }, streamHandler) => {
  const response = await fetch(`${apiUrl}/api/v1/ai-assistant/message`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${Auth.getToken()}`,
      'Accept': 'text/event-stream'
    },
    body: JSON.stringify({
      message,
      context,
      conversation_id: conversationId
    })
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  await streamHandler.handleStream(response);
};

export const executeAIAction = async ({ actionType, actionData, status }) => {
  const response = await client.post('/api/v1/ai-assistant/action', {
    action_type: actionType,
    action_data: actionData,
    status
  });

  return response.data;
};

export const getConversation = async (conversationId) => {
  const response = await client.get(`/api/v1/ai-assistant/conversation/${conversationId}`);
  return response.data;
};

export const getPageContext = async ({ pageType, pageId }) => {
  const response = await client.get('/api/v1/ai-assistant/context', {
    params: {
      page_type: pageType,
      page_id: pageId
    }
  });

  return response.data;
};

export const trackAIUsage = async ({ tokensUsed, model }) => {
  const response = await client.post('/api/v1/ai-assistant/usage', {
    tokens_used: tokensUsed,
    model
  });

  return response.data;
};
